import axios from './BaseService';

const MARKETPLACE_URL = `${process.env.REACT_APP_API_URL}/marketplace/`;

export async function getMarketplaceBots(symbol = '', page = 1) {
    const params = new URLSearchParams({ page });
    if (symbol) params.set('symbol', symbol);
    const response = await axios.get(`${MARKETPLACE_URL}bots?${params.toString()}`);
    return response.data;
}